// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__2T4FJ","element":"style__element__No6QY"};